import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRegionDetail } from "../../../../api/User/commonApi";
import {
  clearClientData,
  selectedClientData,
} from "../../../../Redux/Reducer/ClientDataReducer";
import toastFile from "../../../../Service/ToastFile";
import Required from "../../../Required";
import Fontstyling, { clientListDrpDwnStyles } from "../../comman";
import ClientList from "../../ClientList";

const DetailsHeader = ({ setModalShow, setWitchAction, page }) => {
  const dispatch = useDispatch();
  const client = useSelector((state) => state.clientData.value);
  const [selectedClientvalue, setSelectedClientValue] = useState(null);
  const [clientData, setClientData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [inputValue, setInputValue] = useState({
    clientName: client ? client?.clientName : "SELECT CLIENT NAME",
    iaId: client ? client?.clientID : "",
    hubLocalRegion: "",
    hubRegion: "",
    hubSuperRegion: "",
  });

  const { clientName, iaId, hubLocalRegion, hubRegion, hubSuperRegion } =
    inputValue;

  useEffect(() => {
    if (client !== null && client?.client !== 0)
      setSelectedClientValue({
        value: client?.clientID,
        label: client?.clientName,
      });
    else
      setSelectedClientValue({
        value: 0,
        label: "SELECT CLIENT NAME",
      });
    getRegionData();
  }, []);

  const getRegionData = async () => {
    await getRegionDetail().then((res) => {
      if (res?.status === 200 || res?.status === 204) {
        setRegionData(res.data);
        if (client !== null) {
          let region = res.data?.find(
            (item) => item.regionID === client?.regionId
          );
          setInputValue((prev) => ({
            ...prev,
            hubLocalRegion: region?.hubLocal,
            hubRegion: region?.hubRegion,
            hubSuperRegion: region?.hubSuperRegion,
          }));
        }
      }
    });
  };

  const handleClientChange = (option) => {
    setSelectedClientValue(option);
    if (option.value === 0) {
      dispatch(clearClientData(null));
      return;
    }
    let findedClientData = clientData.find(
      (item) => item.clientID === option.value
    );
    dispatch(selectedClientData(findedClientData));
    let region = regionData?.find(
      (item) => item.regionID === findedClientData.regionId
    );
    setInputValue((prev) => ({
      clientName: findedClientData?.clientName,
      iaId: findedClientData.clientID,
      hubLocalRegion: region === undefined ? "" : region?.hubLocal,
      hubRegion: region === undefined ? "" : region?.hubRegion,
      hubSuperRegion: region === undefined ? "" : region?.hubSuperRegion,
    }));
  };

  return (
    <>
      <div className="d-flex align-items-center mb-3">
        <p
          style={{ ...Fontstyling.heading, whiteSpace: "pre",margin:0 , marginTop: -2.5 }}
        >
          Company Details:{"  "}
        </p>
        <p className="m-0" style={Fontstyling.primaryparagraph}>
          {"("}To edit an existing company, return to the Company Set Up Page
          {")"}:
        </p>
      </div>
      <div className="row">
        <div className="col px-1">
          <label
            htmlFor="inputEmail4"
            className="form-label text-nowrap"
            style={Fontstyling.label}
          >
            Company Name: (Must be in BenefitPoint) <Required />
          </label>
          <ClientList
            clientData={clientData}
            setClientData={setClientData}
            customStyles={clientListDrpDwnStyles}
            handleClientChange={handleClientChange}
            selectedClientvalue={selectedClientvalue}
            setSelectedClientValue={setSelectedClientValue}
          />
        </div>
        <div className="col px-1">
          <label
            htmlFor="inputEmail4"
            className="form-label text-nowrap"
            style={Fontstyling.label}
          >
            IA ID
          </label>
          <input
            type="number"
            value={iaId}
            name="iaId"
            //onChange={handleChange}
            className="form-control rounded-0 py-1"
            style={Fontstyling.label}
            placeholder="0"
            disabled
          />
        </div>
        <div className="col px-1">
          <label
            htmlFor="inputEmail4"
            className="form-label text-nowrap"
            style={Fontstyling.label}
          >
            HUB Local Region
          </label>
          <input
            type="text"
            name="hubLocalRegion"
            value={hubLocalRegion}
            //onChange={handleChange}
            className="form-control rounded-0 py-1"
            style={Fontstyling.label}
            disabled
            placeholder="Link to company name"
          />
        </div>
        <div className="col px-1">
          <label
            htmlFor="inputEmail4"
            className="form-label text-nowrap"
            style={Fontstyling.label}
          >
            HUB Region:
          </label>
          <input
            type="text"
            value={hubRegion}
            name="hubRegion"
            //onChange={handleChange}
            className="form-control rounded-0 py-1"
            style={Fontstyling.label}
            disabled
            placeholder="Link to Local Region"
          />
        </div>
        <div className="col px-1">
          <label
            htmlFor="inputEmail4"
            className="form-label text-nowrap"
            style={Fontstyling.label}
          >
            HUB Super Region
          </label>
          <input
            type="text"
            value={hubSuperRegion}
            name="hubSuperRegion"
            //onChange={handleChange}
            className="form-control rounded-0 py-1"
            style={Fontstyling.label}
            disabled
            placeholder="Link to HUB Region"
          />
        </div>
      </div>
      <div className="text-end mt-3">
        <button
          className="text-nowrap"
          style={Fontstyling.addnewbutton}
          onClick={() => {
            if (clientName === "SELECT CLIENT NAME") {
              toastFile("Select Client");
            } else {
              setModalShow(true);
              setWitchAction("add");
            }
          }}
        >
          {page === "credential"
            ? "Add New Credential"
            : page === "rebatesandreimbursements"
            ? "Add New Rebates and Reimbursements"
            : "Add New Plan"}
        </button>
      </div>
    </>
  );
};

export default DetailsHeader;
